/**
 * DevExtreme (esm/__internal/pagination/utils/calculate_values_fitted_width.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const oneDigitWidth = 10;
export function calculateValuesFittedWidth(minWidth, values) {
  return minWidth + 10 * Math.max(...values).toString().length;
}